import React, { useState, useContext, useRef, useEffect } from "react";
import { GlobalContext } from "../../../App";
import L from "leaflet";
import "../../Print/Leaflet.BigImage";
import "../../Print/Leaflet.BigImage.css";
// import Modal from 'react-modal';
import files from "../../static";
import html2canvas from "html2canvas";
import "./tools.css";
import "leaflet/dist/leaflet.css";
import { Rnd } from "react-rnd";
import jsPDF from "jspdf";
import MapTemplate from "./MapTemplate";
import { addLegendToMap } from "./addLegend";

export default function MapCreation() {
  const {
    map,
    vis,
    selectedLayers,
    Canvas,
    showGrid,
    setGrid,
    Grat,
    selectedTemplate,
    setSelectedTemplate,
    selectedLayout,
    setSelectedLayout,
  } = useContext(GlobalContext);
  const [show, setshow] = useState(false);
  const toolRef = useRef(null);
  const [elements, setElements] = useState([]);
  const [editingElementId, setEditingElementId] = useState(null);
  const [mapPreview, setMapPreview] = useState(null);
  const [loader, setLoader] = useState(false);
  const [exportFormat, setExportFormat] = useState("pdf");
  const [localGraticule, setLocalGraticule] = useState(null);
  const canvasScaleRef = useRef(null);
  const[minimize,setMinimize]=useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        editingElementId &&
        !document.getElementById(editingElementId)?.contains(e.target)
      ) {
        setEditingElementId(null); // Exit edit mode when clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [editingElementId]);

  useEffect(() => {
    if (!map) return;

    const captureMap = () => {
      const controls = document.querySelectorAll(
        ".leaflet-top, .leaflet-bottom"
      );
      controls.forEach((el) => (el.style.display = "none"));

      const target = document.querySelector(".leaflet-container");

      if (target) {
        const frame = document.getElementById("layer-frame");
        const frameWidth = frame?.offsetWidth || target.offsetWidth;
        const frameHeight = frame?.offsetHeight || target.offsetHeight;

        html2canvas(target, {
          useCORS: true,
          allowTaint: true,
          backgroundColor: null,
          width: frameWidth,
          height: frameHeight,
        })
          .then((canvas) => {
            const dataUrl = canvas.toDataURL("image/png");
            setMapPreview(dataUrl);
            controls.forEach((el) => (el.style.display = ""));
          })
          .catch((err) => {
            console.error("Map capture failed:", err);
            controls.forEach((el) => (el.style.display = ""));
          });
      }

    };
    
    const onTilesLoaded = () => {
      captureMap();
    };

    const updatePreview = () => {
      // Capture after tile load
      setTimeout(() => captureMap(), 0); // Ensure it's captured after DOM update
    };

    map.whenReady(() => {
      // Capture initially when the map is ready
      updatePreview();

      // Capture after zooming or panning
      map.on("moveend", updatePreview);
      map.on("zoomend", updatePreview);

      // Ensure the capture happens after all tiles have been loaded
      map.on("tileload", onTilesLoaded); // Capture when all tiles for the zoom level are loaded
    });

    return () => {
      map.off("moveend", updatePreview);
      map.off("zoomend", updatePreview);
      map.off("tileload", onTilesLoaded);
    };
  }, [map]);

  useEffect(() => {
    if (!map) return;

    const onZoom = () => {
      const scaleContainer = document.querySelector(
        ".leaflet-control-scale.leaflet-control"                             
      );
      if (scaleContainer && canvasScaleRef.current) {
        const newClone = scaleContainer.cloneNode(true);
        newClone.style.all = "unset";
        newClone.style.fontSize = "10px";
        newClone.style.padding = "4px";
        newClone.style.color = "black";
        newClone.style.textAlign = "center";

        const el = canvasScaleRef.current;
        el.innerHTML = ""; // Clear old content
        el.appendChild(newClone); // Add new one
      }
    };

    map.on("zoomend", onZoom);
    return () => {
      map.off("zoomend", onZoom);
    };
  }, [map]);


  useEffect(() => {
    console.log(" showGrid changed:", showGrid);
    console.log(" localGraticule updated:", localGraticule);
  }, [showGrid, localGraticule]);

  // const updateMapPreview = () => {
  //   const target = document.querySelector(".leaflet-container");
  //   if (!target) return;

  //   const controls = document.querySelectorAll(".leaflet-top, .leaflet-bottom");
  //   controls.forEach((el) => (el.style.display = "none"));

  //   setTimeout(() => {
  //     html2canvas(target, {
  //       useCORS: true,
  //       allowTaint: true,
  //       backgroundColor: null,
  //     }).then((canvas) => {
  //       setMapPreview(canvas.toDataURL("image/png"));
  //       controls.forEach((el) => (el.style.display = ""));
  //     });
  //   }, 300);
  // };

  const handletemplateChange = (e) => {
    const templateValue = e.target.value;
    setSelectedTemplate(templateValue);
    console.log("Selected template:", templateValue);
  };

  const handleLayoutChange = (e) => {
    const layoutValue = e.target.value;
    setSelectedLayout(layoutValue);
    setElements([]);
    setGrid(false);
    console.log("in layoutchange", showGrid);
  };

  // const handleElementSelect = (e) => {
  //   setshow(false);
  //   const type = e.target.value;
  //   const id = `${type}-${Date.now()}`;
  //   const defaultPos = { x: 50, y: 50 };

  //   if (type === "1") {
  //     setElements((prev) => [
  //       ...prev,
  //       {
  //         id,
  //         type,
  //         content: { title: "Map Title", subtitle: "Subtitle here" },
  //         x: defaultPos.x,
  //         y: defaultPos.y,
  //       },
  //     ]);
  //   } else if (type === "3") {
  //     setElements((prev) => [
  //       ...prev,
  //       {
  //         id,
  //         type,
  //         content: (
  //           <img
  //             src={`${process.env.PUBLIC_URL}/${files}north_arrow.svg`}
  //             alt="North Arrow"
  //             style={{ width: "40px", height: "40px" }}
  //           />
  //         ),
  //         x: defaultPos.x,
  //         y: defaultPos.y,
  //       },
  //     ]);
  //   } else {
  //     const defaultContent = {
  //       2: "Legend goes here",
  //       4: "Scale Bar",
  //     }[type];

  //     setElements((prev) => [
  //       ...prev,
  //       {
  //         id,
  //         type,
  //         content: defaultContent,
  //         x: defaultPos.x,
  //         y: defaultPos.y,
  //       },
  //     ]);
  //   }
  // };

  // Function to clone layers and add them to layout frame

  // const handleElementSelect = (e) => {
  //   setshow(false);
  //   const type = e.target.value;
  //   const id = `${type}-${Date.now()}`;
  //   const defaultPos = { x: 50, y: 50 };

  //   const layers =
  //     selectedLayers && typeof selectedLayers === "object"
  //       ? Object.values(selectedLayers)
  //       : [];

  //   const timestamp = Date.now();

  //   const getLayerName = (layer) => {
  //     if (layer instanceof L.Polygon) return "Polygon";
  //     if (layer instanceof L.Polyline) return "Line";
  //     if (layer instanceof L.Marker) return "Marker";
  //     if (layer instanceof L.Rectangle) return "Rectangle";
  //     if (layer instanceof L.Circle) return "Circle";
  //     if (layer instanceof L.CircleMarker) return "Circle Marker";
  //     if (layer instanceof L.TileLayer) return "Tile Layer";
  //     if (layer._url) return "Tile Layer";
  //     return "Unknown Layer";
  //   };

  //   if (type === "2") {
  //     const legendElements = [];

  //     // Step 1: Iterate over selectedLayers
  //     Object.entries(selectedLayers).forEach(([key, layer]) => {
  //       if (key === "Basemap") return;
  //       let name = key.split("#")[0];

  //       let legendIcon = null;

  //       if (layer instanceof L.Rectangle) {
  //         legendIcon = (
  //           <svg width="20" height="12">
  //             <rect x="0" y="0" width="18" height="12" style={{ fill: "none", strokeWidth: 2, stroke: "#558bcc" }} />
  //           </svg>
  //         );
  //       } else if (layer instanceof L.Polygon) {
  //         legendIcon = (
  //           <svg width="20" height="20">
  //             <polygon points="9,1 19,7 16,17 5,17 1,8" style={{ fill: "none", strokeWidth: 1.5, stroke: "#558bcc" }} />
  //           </svg>
  //         );
  //       } else if (layer instanceof L.Polyline) {
  //         legendIcon = (
  //           <svg width="20" height="20">
  //             <circle cx="15" cy="3" r="2" fill="#558bcc" />
  //             <circle cx="3" cy="15" r="2" fill="#558bcc" />
  //             <line x1="15" y1="3" x2="3" y2="15" stroke="#558bcc" strokeWidth="1.5" />
  //           </svg>
  //         );
  //       } else if (layer instanceof L.Marker) {
  //         legendIcon = (
  //           <img src={`${process.env.PUBLIC_URL}/${files}gps.png`} width="15" height="15" alt="Marker Icon" />
  //         );
  //       } else if (layer instanceof L.GeoJSON) {
  //         const color = layer.options?.style?.color || "#558bcc";
  //         legendIcon = (
  //           <svg width="20" height="20">
  //             <polygon points="9,1 19,7 16,17 5,17 1,8" style={{ fill: "none", strokeWidth: 1.5, stroke: color }} />
  //           </svg>
  //         );
  //       } else {
  //         legendIcon = (
  //           <img src={`${process.env.PUBLIC_URL}/${files}img_icon.png`} width="15" height="15" alt="Default Icon" />
  //         );
  //       }

  //       legendElements.push({
  //         id: `${name}-${timestamp}`,
  //         type,
  //         content: (
  //           <div style={{ display: "flex", alignItems: "center" }}>
  //             {legendIcon}
  //             <span style={{ marginLeft: "10px" }}>{name}</span>
  //           </div>
  //         ),
  //         x: defaultPos.x,
  //         y: defaultPos.y,
  //       });
  //     });

  //     // Step 2: Canvas.getLayersColor()
  //     const vectors = Canvas.getLayersColor(); // Assumes Canvas is in scope

  //     vectors.forEach((info) => {
  //       let legendIcon = null;
  //       if (info.type === "polygon") {
  //         legendIcon = (
  //           <svg width="20" height="20">
  //             <polygon points="9,1 19,7 16,17 5,17 1,8" style={{ fill: "none", strokeWidth: 1.5, stroke: info.color }} />
  //           </svg>
  //         );
  //       } else if (info.type === "point") {
  //         legendIcon = (
  //           <svg width="20" height="20">
  //             <circle cx="10" cy="10" r="5" fill={info.color} />
  //           </svg>
  //         );
  //       }

  //       legendElements.push({
  //         id: `${info.name}-${timestamp}`,
  //         type,
  //         content: (
  //           <div style={{ display: "flex", alignItems: "center" }}>
  //             {legendIcon}
  //             <span style={{ marginLeft: "10px" }}>{info.name}</span>
  //           </div>
  //         ),
  //         x: defaultPos.x,
  //         y: defaultPos.y,
  //       });
  //     });

  //     setElements((prev) => {
  //       const existingIds = new Set(prev.map((el) => el.id));
  //       const allNew = legendElements.filter((el) => !existingIds.has(el.id));
  //       return [...prev, ...allNew];
  //     });
  //   } else if (type === "1") {
  //     setElements((prev) => [
  //       ...prev,
  //       {
  //         id,
  //         type,
  //         content: { title: "Map Title", subtitle: "Subtitle here" },
  //         x: defaultPos.x,
  //         y: defaultPos.y,
  //       },
  //     ]);
  //   } else if (type === "3") {
  //     setElements((prev) => [
  //       ...prev,
  //       {
  //         id,
  //         type,
  //         content: (
  //           <img
  //             src={`${process.env.PUBLIC_URL}/${files}north_arrow.svg`}
  //             alt="North Arrow"
  //             style={{ width: "40px", height: "40px" }}
  //           />
  //         ),
  //         x: defaultPos.x,
  //         y: defaultPos.y,
  //       },
  //     ]);
  //   }
  // };

  const handleElementSelect = (e) => {
    setshow(false);
    const type = e.target.value;
    const id = `${type}-${Date.now()}`;
    const defaultPos = { x: 50, y: 50 };

    // const layers =
    //   selectedLayers && typeof selectedLayers === "object"
    //     ? Object.values(selectedLayers)
    //     : [];

    const timestamp = Date.now(); 

//Map Creation code for legend - 10 April 2026 - Shakshi Agrawal
if (type === "2") {
  const timestamp = Date.now();

  setTimeout(() => {
    const legendElements = [];

    // ── 1. Float panels — search entire document ─────────────────────────
    const floatPanels = document.querySelectorAll("[id^='float-legend-']");
    console.log("Float panels found (doc):", floatPanels.length, 
      [...floatPanels].map(p => p.id));

    floatPanels.forEach((panel, index) => {
      const body = panel.querySelector(".float-legend-body");
      if (!body) return;
      legendElements.push({
        id: `layout-legend-float-${timestamp}-${index}`,
        type: "2",
        content: (
          <div style={{
            background: "white", border: "1px solid #ccc",
            padding: "8px", borderRadius: "4px", fontSize: "12px",
            marginBottom: "6px"
          }}
            dangerouslySetInnerHTML={{ __html: body.innerHTML }}
          />
        ),
        x: defaultPos.x + index * 15,
        y: defaultPos.y + index * 15,
      });
    });

    // ── 2. Shared panel ───────────────────────────────────────────────────
    const sharedItems = document.querySelectorAll(
      "#shared-legend-items [data-legend-id]"
    );
    console.log("Shared items found (doc):", sharedItems.length);

    sharedItems.forEach((item, index) => {
      const body = item.querySelector(".legend-entry-body");
      if (!body) return;
      legendElements.push({
        id: `layout-legend-shared-${timestamp}-${index}`,
        type: "2",
        content: (
          <div style={{
            background: "white", border: "1px solid #ccc",
            padding: "8px", borderRadius: "4px", fontSize: "12px",
            marginBottom: "6px"
          }}
            dangerouslySetInnerHTML={{ __html: body.innerHTML }}
          />
        ),
        x: defaultPos.x + (floatPanels.length + index) * 15,
        y: defaultPos.y + (floatPanels.length + index) * 15,
      });
    });

    // ── 3. Unified panel ──────────────────────────────────────────────────
    const unifiedItems = document.querySelectorAll(
      "#legend-items-container [data-legend-id]"
    );
    console.log("Unified items found (doc):", unifiedItems.length);

    unifiedItems.forEach((item, index) => {
      const body = item.querySelector(".legend-entry-body");
      if (!body) return;
      legendElements.push({
        id: `layout-legend-unified-${timestamp}-${index}`,
        type: "2",
        content: (
          <div style={{
            background: "white", border: "1px solid #ccc",
            padding: "8px", borderRadius: "4px", fontSize: "12px",
            marginBottom: "6px"
          }}
            dangerouslySetInnerHTML={{ __html: body.innerHTML }}
          />
        ),
        x: defaultPos.x + (floatPanels.length + sharedItems.length + index) * 15,
        y: defaultPos.y + (floatPanels.length + sharedItems.length + index) * 15,
      });
    });

    console.log("Total legend elements collected:", legendElements.length);

    if (legendElements.length === 0) {
      // ── 4. Last resort: dump ALL legend-like divs found anywhere ────────
      const allLegendDivs = document.querySelectorAll(
        "[id*='legend'], [class*='legend']"
      );
      console.log("All legend-related elements in DOM:", 
        [...allLegendDivs].map(el => ({ 
          id: el.id, 
          class: el.className, 
          parent: el.parentElement?.id || el.parentElement?.className 
        }))
      );
      console.warn("No legend data found on map.");
      return;
    }

    setElements((prev) => {
      const existingIds = new Set(prev.map((el) => el.id));
      return [...prev, ...legendElements.filter((el) => !existingIds.has(el.id))];
    });

  }, 200);
}

    else if (type === "1") {
      setElements((prev) => {
        const alreadyExists = prev.some((el) => el.type === "1");
        if (alreadyExists) return prev;

        return [
          ...prev,
          {
            id,
            type,
            content: (
              <div style={{ textAlign: "center" }}>
                <h3 style={{ margin: 0 }}>Map Title</h3>
                <p style={{ margin: 0 }}>Subtitle here</p>
              </div>
            ),
            x: defaultPos.x,
            y: defaultPos.y,
          },
        ];
      });
    }
    else if (type === "3") {
      setElements((prev) => {
        const alreadyExists = prev.some((el) => el.type === "3");
        if (alreadyExists) return prev;
        return [
          ...prev,
          {
            id,
            type,
            content: (
              <img
                src={`${process.env.PUBLIC_URL}/${files}north-arrow.png`}
                alt="North Arrow"
                style={{ width: "40px", height: "40px" }}
              />
            ),
            x: defaultPos.x,
            y: defaultPos.y,
          },
        ];
      });
    } else if (type === "4") {
      setElements((prev) => {
        const alreadyExists = prev.some((el) => el.type === "4");
        if (alreadyExists || !map) return prev;

        const id = `scale-${Date.now()}`;
        const defaultPos = { x: 50, y: 50 };

        // Create a temporary scale control
        const scaleControl = L.control
          .scale({
            position: "bottomright",
            imperial: false,
            maxWidth: 100,
          })
          .addTo(map);

        setTimeout(() => {
          const scaleContainer = document.querySelector(
            ".leaflet-control-scale.leaflet-control"
          );

          if (scaleContainer) {
            const cloned = scaleContainer.cloneNode(true);
            cloned.style.all = "unset";
            cloned.style.fontSize = "10px";
            cloned.style.padding = "4px";
            cloned.style.color = "black";
            cloned.style.textAlign = "center";

            setElements((prev) => [
              ...prev,
              {
                id,
                type: "4",
                content: (
                  <div
                    ref={(el) => {
                      if (el && !el.hasChildNodes()) {
                        canvasScaleRef.current = el;
                        el.appendChild(cloned);
                      }
                    }}
                  />
                ),
                x: defaultPos.x,
                y: defaultPos.y,
              },
            ]);
          }

          map.removeControl(scaleControl);
        }, 500);

        return prev; // Placeholder until cloned element is added
      });
    }
    //     else if (type === "5") {
    //       if (!selectedLayout) {
    //     alert("Please select a layout first.");
    //     return;
    //   }

    //   setGrid((prev) => !prev);
    //   console.log("Grid toggled, now showGrid =", !showGrid); // 🔍 confirm
    // }
    else if (type === "5" && selectedLayout) {
      if (!selectedLayout) {
        alert("Please select a layout first.");
        return;
      }

      // Clean up any existing grid
      if (map.hasLayer(Grat)) {
        map.removeLayer(Grat);
        console.log(" Removed default black graticule");
      }

      // Remove old labels
      document.querySelectorAll("svg text").forEach((el) => {
        if (el.textContent.includes("°")) el.remove();
      });

      // Add transparent graticule directly
      const tempGraticule = L.latlngGraticule({
        showLabel: true,
        width: 5,
        fontColor: "#FFF907", // dark yellow
        font: "18px bolder",
        color: "transparent",
        zoomInterval: Grat.options.zoomInterval,
      });

      tempGraticule.addTo(map);
      setLocalGraticule(tempGraticule);
      setGrid(true); // set state true if you want to track it

      console.log(
        "in habdleelement select ",
        showGrid,
        "graticule:",
        localGraticule
      );

      // Remove black stroke immediately
      setTimeout(() => {
        const svg = document.querySelector("svg");
        if (svg) {
          svg.querySelectorAll("path").forEach((p) => {
            if (p.getAttribute("stroke") !== "none") {
              p.setAttribute("stroke", "none");
            }
          });
        }
      }, 50);

      //  Start observing DOM to kill future strokes
      const svgRoot = document.querySelector(".leaflet-map-pane");
      const observer = new MutationObserver(() => {
        const svg = document.querySelector("svg");
        if (svg) {
          svg.querySelectorAll("path").forEach((p) => {
            if (p.getAttribute("stroke") !== "none") {
              p.setAttribute("stroke", "none");
            }
          });
        }
      });

      if (svgRoot) {
        observer.observe(svgRoot, {
          childList: true,
          subtree: true,
        });
      }

      // Store observer for cleanup (optional)
      // setGridObserver(observer); ← Only if you track cleanup elsewhere
    }
  };

  // Remove handler
  const removeLegend = (id) => {
    setElements((prev) => prev.filter((el) => el.id !== id));
  };

  const handleLayerExport = () => {
    setLoader(true);

    const container =
      selectedTemplate === "Location-map"
        ? document.querySelector(".location-map-template-inner-container")
        : document.getElementById("layer-frame");

    if (!container) {
      console.error("Map container not found!");
      setLoader(false);
      return;
    }

    const originalBorder = container.style.border;
    const originalOverflow = container.style.overflow;
    container.style.border = "none";
    container.style.overflow = "visible";

    const containerWidth = container.offsetWidth;
    const containerHeight = container.offsetHeight;

    setTimeout(() => {
      html2canvas(container, {
        useCORS: true,
        scale: 2,
        width: containerWidth,
        height: containerHeight,
        backgroundColor: null,
        svgRendering: true,
        allowTaint: true,
        scrollX: 0,
        scrollY: 0,
        x: 0,
        y: 0,

        onclone: (clonedDoc) => {

          // 🔹 Remove all <select> tags
          clonedDoc.querySelectorAll("select").forEach((el) => el.remove());

          // 🔹 Flatten ALL draggable elements (titles, subtitles, legends, arrows, etc.)
          const clonedLegend = clonedDoc.getElementById("legend-container");
          if (clonedLegend) {
            clonedLegend.style.position = "absolute";
            clonedLegend.style.top = "0";
            clonedLegend.style.left = "0";
            clonedLegend.style.zIndex = "9999";
            clonedLegend.style.maxHeight = "none";
            clonedLegend.style.overflow = "visible";
          }

          const northArrow = clonedDoc.getElementById("north-arrow");
          if (northArrow) {
            northArrow.style.display = "block";
            northArrow.style.visibility = "visible";
          }

          // 🔹 Fix Leaflet tiles & overlay transforms
          clonedDoc.querySelectorAll(".leaflet-tile, .leaflet-overlay-pane svg").forEach((el) => {
            const style = window.getComputedStyle(el);
            const transform = style.transform;
            if (transform && transform !== "none") {
              const matrix = new DOMMatrix(transform);
              const left = parseFloat(style.left || 0) + matrix.m41;
              const top = parseFloat(style.top || 0) + matrix.m42;
              el.style.transform = "none";
              el.style.left = `${left}px`;
              el.style.top = `${top}px`;
              el.style.position = "absolute";
            }
          });

          // 🔹 Fix Map4 image shrink
          const map4 = clonedDoc.getElementById("map4");
          if (map4) {
            const img = map4.querySelector("img");
            if (img) {
              img.style.width = map4.offsetWidth + "px";
              img.style.height = map4.offsetHeight + "px";
              img.style.objectFit = "fill";
              img.style.position = "absolute";
            }
          }
        },


      })
        .then((canvas) => {
          // const imgData = canvas.toDataURL("image/jpeg", 1.0);

          // if (exportFormat === "pdf") {
          //   const margin = 40;
          //   const pageWidth = containerWidth + 2 * margin;
          //   const pageHeight = containerHeight + 2 * margin;

          //   const pdf = new jsPDF({
          //     orientation: pageWidth > pageHeight ? "landscape" : "portrait",
          //     unit: "px",
          //     format: [pageWidth, pageHeight],
          //   });

          //   pdf.setFillColor(255, 255, 255, 0);
          //   pdf.addImage(imgData, "JPEG", margin, margin, containerWidth, containerHeight);
          //   pdf.save("map_export.pdf");
          // } else if (exportFormat === "jpg") {
          //   const link = document.createElement("a");
          //   link.href = imgData;
          //   link.download = "map_export.jpg";
          //   document.body.appendChild(link);
          //   link.click();
          //   document.body.removeChild(link);
          // }

          
          const imgData = canvas.toDataURL("image/jpeg", 1.0);

          if (exportFormat === "pdf") {
            const margin = 15;
          
            // Always standard A4 size
            const pdfOrientation =
              containerWidth > containerHeight ? "landscape" : "portrait";
          
            const pdf = new jsPDF({
              orientation: pdfOrientation,
              unit: "px",
              format: "a4",   // Force exact A4
            });
          
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
          
            // 🔹 Fit inside A4 minus margins
            const maxWidth = pageWidth - 2 * margin;
            const maxHeight = pageHeight - 2 * margin;
          
            const aspectRatio = containerWidth / containerHeight;
            let renderWidth = maxWidth;
            let renderHeight = renderWidth / aspectRatio;
          
            if (renderHeight > maxHeight) {
              renderHeight = maxHeight;
              renderWidth = renderHeight * aspectRatio;
            }
          
            // Center image within page
            const x = (pageWidth - renderWidth) / 2;
            const y = (pageHeight - renderHeight) / 2;
          
            pdf.addImage(imgData, "JPEG", x, y, renderWidth, renderHeight);
            pdf.save("map_export.pdf");
          } else if (exportFormat === "jpg") {
            const link = document.createElement("a");
            link.href = imgData;
            link.download = "map_export.jpg";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }          

        })
        .catch((error) => {
          console.error("Error exporting:", error);
        })
        .finally(() => {
          container.style.border = originalBorder;
          container.style.overflow = originalOverflow;
          setLoader(false);
        });
    }, 500);
  };


  const handleMinimize = () => {
    setMinimize(true);
    const locationMapFrame = document.getElementById("location-map-frame");
    locationMapFrame.style.width = "500px";
    locationMapFrame.style.height = "500px";
  };

  const handleMaximize = () => {
        setMinimize(false);
    const locationMapFrame = document.getElementById("location-map-frame");
    if (selectedLayout === "1") {
      locationMapFrame.style.width = "1680px";
      locationMapFrame.style.height = "815px";
    } else {
      locationMapFrame.style.width = "800px";
      locationMapFrame.style.height = "830px";
    }
  };

return (
  <>
    <div style={{ position: vis ? "absolute" : "relative" }} className="toolscont">

      {/* ── Trigger Button ── */}
      <button
        className="btn text-white"
        title="Map Creation"
        id="mapcreation"
        onClick={() => setshow(!show)}
        style={{ backgroundColor: "black", width: "40px", height: "40px", borderRadius: "50%", border: "none" }}
      >
        <i className="fa-solid fa-map-location-dot" />
      </button>

      {show && (
        <div
          ref={toolRef}
          className="toolsvis"
          style={{ position: "absolute", top: "40px", left: "5px", zIndex: 10000, width: "300px", padding: "10px 12px" }}
        >
          {/* ── Header ── */}
          <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            paddingBottom: "8px", marginBottom: "10px",
            borderBottom: "1px solid rgba(255,255,255,0.12)"
          }}>
            <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
              <i className="fa-solid fa-map-location-dot" style={{ marginRight: "6px", fontSize: "11px" }} />
              Map Creation
            </span>
            <span
              onClick={() => setshow(false)}
              style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
            >
              &times;
            </span>
          </div>

          {/* ── Loader ── */}
          {loader && (
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <div className="lds-dual-ring">
                <i className="fa-solid fa-globe" />
              </div>
            </div>
          )}

          {/* ── Selects ── */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <select
              className="form-select text-white swipe-options"
              onChange={handletemplateChange}
              style={{ backgroundColor: "transparent", border: "1px solid rgba(255,255,255,0.25)", fontSize: "12px", color: "white" }}
            >
              <option>Select Template</option>
              <option value="Standard-map">Standard Map</option>
              <option value="Location-map">Location Map</option>
            </select>

            <select
              className="form-select text-white swipe-options"
              onChange={handleLayoutChange}
              style={{ backgroundColor: "transparent", border: "1px solid rgba(255,255,255,0.25)", fontSize: "12px", color: "white" }}
            >
              <option>Select Layout</option>
              <option value="1">A4 - Landscape</option>
              <option value="2">A4 - Portrait</option>
            </select>

            <select
              className="form-select text-white swipe-options"
              onChange={handleElementSelect}
              style={{ backgroundColor: "transparent", border: "1px solid rgba(255,255,255,0.25)", fontSize: "12px", color: "white" }}
            >
              <option value="" disabled>Map Elements</option>
              <option value="1">Title and Subtitle</option>
              <option value="2">Legends</option>
              <option value="3">North Arrow</option>
              <option value="4">Scale Bar</option>
              <option value="5">Grid</option>
            </select>

            <select
              className="form-select text-white swipe-options"
              value={exportFormat}
              onChange={(e) => setExportFormat(e.target.value)}
              style={{ backgroundColor: "transparent", border: "1px solid rgba(255,255,255,0.25)", fontSize: "12px", color: "white" }}
            >
              <option value="pdf">Export as PDF</option>
              <option value="jpg">Export as JPG</option>
            </select>
          </div>

          {/* ── Action Buttons ── */}
          <div style={{ display: "flex", gap: "8px", marginTop: "12px" }}>
            <button
              className="btn btn-primary border-0"
              style={{ flex: 1, fontSize: "12px", height: "32px" }}
              onClick={handleLayerExport}
            >
              Export Layout
            </button>
            <button
              className="btn btn-outline-danger"
              style={{ flex: 1, fontSize: "12px", height: "32px" }}
              onClick={() => {
                if (localGraticule && map.hasLayer(localGraticule)) {
                  map.removeLayer(localGraticule);
                }
                document.querySelectorAll("svg text").forEach((el) => {
                  if (el.textContent.includes("°")) el.remove();
                });
                setSelectedTemplate(null);
                setSelectedLayout(null);
                setGrid(false);
                setLocalGraticule(null);
                setElements([]);
              }}
            >
              Clear Layout
            </button>
          </div>

        </div>
      )}
    </div>

    {/* ── Standard Map Frame ── */}
    {selectedTemplate === "Standard-map" && selectedLayout && (
      <div
        id="layer-frame"
        className={`layout-frame ${selectedLayout === "1" ? "a4-landscape" : "a4-portrait"}`}
        style={{
          position: "absolute", top: 35,
          left: selectedLayout === "1" ? "5%" : "50%",
          border: "5px solid black", marginTop: "10px",
          width: selectedLayout === "1" ? "1680px" : "715px",
          height: "815px",
          boxSizing: "border-box", overflow: "visible", zIndex: 500,
        }}
      >
        {map && mapPreview && (
          <img
            src={mapPreview} alt="Map preview"
            style={{ width: "100%", height: "100%", objectFit: "cover", position: "absolute", zIndex: 0 }}
          />
        )}

        <img
          src={`${process.env.PUBLIC_URL}/${files}BAIF_logo.jpg`}
          alt="Logo"
          style={{ position: "absolute", bottom: "10px", left: "10px", zIndex: 1, width: "100px" }}
        />

        {elements.filter((el) => el.type !== "2").map((el, index) => (
          <Rnd
            key={el.id}
            default={{ x: el.x, y: el.y, width: "fit-content", height: el.type === "1" ? 100 : 60 }}
            bounds="parent"
            style={{ backgroundColor: "transparent", color: "black", padding: "8px", border: "none", fontSize: "14px", cursor: "move" }}
          >
            <div id={el.id} onClick={(e) => { e.stopPropagation(); setEditingElementId(el.id); }}>
              {el.type === "1" ? (
                editingElementId === el.id ? (
                  <div>
                    <input
                      type="text" value={el.content.title} placeholder="Title"
                      className="form-control mb-2"
                      style={{ backgroundColor: "white", color: "black", border: "1px solid black" }}
                      onChange={(e) => {
                        const updated = [...elements];
                        updated[index] = { ...updated[index], content: { ...updated[index].content, title: e.target.value } };
                        setElements(updated);
                      }}
                      autoFocus
                    />
                    <input
                      type="text" value={el.content.subtitle} placeholder="Subtitle"
                      className="form-control"
                      style={{ backgroundColor: "white", color: "black", border: "1px solid black" }}
                      onChange={(e) => {
                        const updated = [...elements];
                        updated[index] = { ...updated[index], content: { ...updated[index].content, subtitle: e.target.value } };
                        setElements(updated);
                      }}
                    />
                  </div>
                ) : (
                  <div style={{ backgroundColor: "rgba(255,255,255,0.8)", padding: "10px 15px", border: "2px solid black" }}>
                    <div style={{ fontWeight: "bold", fontSize: "20px" }}>{el.content.title}</div>
                    <div style={{ fontSize: "15px" }}>{el.content.subtitle}</div>
                  </div>
                )
              ) : el.content}
            </div>
          </Rnd>
        ))}

        {elements.some((el) => el.type === "2") && (
          <Rnd
            key="legend"
            id="legend-container"
            default={{ x: 10, y: 10, width: "fit-content", height: "fit-content" }}
            bounds="parent"
            style={{
              position: "absolute", zIndex: 1000,
              border: "2px solid black", backgroundColor: "rgba(255,255,255,0.8)",
              padding: "10px 15px", width: "200px", maxWidth: "300px",
              overflowY: "auto", maxHeight: "300px", fontSize: "14px",
            }}
          >
            <div>
              <h5>Legend</h5>
              {elements.filter((el) => el.type === "2").map((el) => (
                <div key={el.id} style={{ marginBottom: "10px" }}>{el.content}</div>
              ))}
            </div>
          </Rnd>
        )}
      </div>
    )}

    {/* ── Location Map Frame ── */}
    {selectedTemplate === "Location-map" && selectedLayout && (
      <div
        id="location-map-frame"
        style={{
          position: "absolute", top: 35,
          left: selectedLayout === "1" ? 20 : "50%",
          border: "2px solid white", backgroundColor: "white",
          marginTop: "10px",
          width: selectedLayout === "1" ? "1680px" : "800px",
          height: selectedLayout === "1" ? "815px" : "830px",
          boxSizing: "border-box", overflow: "visible", zIndex: 500, padding: "10px",
        }}
      >
        <div style={{ position: "absolute", top: "5px", right: "5px", zIndex: 1000 }}>
          <button
            style={{ backgroundColor: "#d80000", padding: "0px 8px", border: "none", color: "white", borderRadius: "3px" }}
            onClick={minimize ? handleMaximize : handleMinimize}
          >
            {minimize ? "+" : "−"}
          </button>
        </div>

        <MapTemplate
          handleElementSelect={handleElementSelect}
          elements={elements}
          removeLegend={removeLegend}
          setElements={setElements}
          editingElementId={editingElementId}
          setEditingElementId={setEditingElementId}
        />
      </div>
    )}
  </>
);
}
